import React, { useCallback, useEffect, useMemo, useState } from 'react';
import icMenu1 from 'Assets/img/header/ic_menu.png';
import icMenu2 from 'Assets/img/header/ic_menu@2x.png';
import icMenu3 from 'Assets/img/header/ic_menu@3x.png';
import icArrowDown1 from 'Assets/img/header/ic_arrow_down_black.png';
import icArrowDown2 from 'Assets/img/header/ic_arrow_down_black@2x.png';
import icArrowDown3 from 'Assets/img/header/ic_arrow_down_black@3x.png';
import icPin1 from 'Assets/img/header/ic_pin_blue.png';
import icPin2 from 'Assets/img/header/ic_pin_blue@2x.png';
import icPin3 from 'Assets/img/header/ic_pin_blue@3x.png';
import icUp1 from 'Assets/img/header/ic_up.png';
import icUp2 from 'Assets/img/header/ic_up@2x.png';
import icUp3 from 'Assets/img/header/ic_up@3x.png';
import icX1 from 'Assets/img/header/ic_x_white.png';
import icX2 from 'Assets/img/header/ic_x_white@2x.png';
import icX3 from 'Assets/img/header/ic_x_white@3x.png';
import icNoty1 from 'Assets/img/header/ic_noty.png';
import icNoty2 from 'Assets/img/header/ic_noty@2x.png';
import icNoty3 from 'Assets/img/header/ic_noty@3x.png';
import { getImageSet } from 'Util/DataUtils';
import { useDispatch, useSelector } from 'react-redux';
import { collapsedSidebarAction, collapsedFieldSidebarAction } from 'Actions';
import IntlMessages from 'Util/IntlMessages';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import useInterval from 'Util/useInterval';
import { collapsedNotificationSidebarAction } from 'Actions/AppSettingsActions';
import UserBlock from './components/UserBlock';
import { isVietnam } from 'Util/DataUtils';
import useNoty from 'Util/useNoty';

const icMenu = getImageSet([icMenu1, icMenu2, icMenu3]);
const icArrowDown = getImageSet([icArrowDown1, icArrowDown2, icArrowDown3]);
const icPin = getImageSet([icPin1, icPin2, icPin3]);
const icUp = getImageSet([icUp1, icUp2, icUp3]);
const icX = getImageSet([icX1, icX2, icX3]);
const icNoty = getImageSet([icNoty1, icNoty2, icNoty3]);

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { navCollapsed, fieldCollapsed, notificationCollapsed } = useSelector(state => state.settings);
  const { defaultField } = useSelector(state => state.config);
  const { formatMessage } = useIntl();
  const isDashboardAll = useMemo(() => location.pathname.indexOf('admin/dashboard') > -1 && location.pathname.indexOf('/field') === -1, [location.pathname]);
  const [isOpenedFieldGuide, setIsOpenedFieldGuide] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const { count, newField, fetchNotyCount, fetchNotyNewField, fetchNotyNewMenu } = useNoty();
  const { user } = useSelector(state => state.authUser);

  useEffect(() => {
    if (isDashboardAll && firstRender) {
      setIsOpenedFieldGuide(true);
    }
    setFirstRender(false);
  }, [isDashboardAll, firstRender]);

  const onToggleNavCollapsed = useCallback(() => {
    dispatch(collapsedSidebarAction(!navCollapsed));
  }, [dispatch, navCollapsed]);

  const onToggleNotyCollapsed = useCallback(() => {
    dispatch(collapsedNotificationSidebarAction(!notificationCollapsed));
  }, [dispatch, notificationCollapsed]);

  const onToggleFieldCollapsed = useCallback(() => {
    dispatch(collapsedFieldSidebarAction(!fieldCollapsed));
    setIsOpenedFieldGuide(false);
    if (!localStorage.getItem('checkFieldGuide')) {
      localStorage.setItem('checkFieldGuide', 'true');
    }
  }, [dispatch, fieldCollapsed]);

  useEffect(() => {
    fetchNotyCount();
    fetchNotyNewField();
    fetchNotyNewMenu();
  }, [fetchNotyCount, fetchNotyNewField, fetchNotyNewMenu]);

  useInterval(() => {
    fetchNotyCount();
    fetchNotyNewField();
    fetchNotyNewMenu();
  }, 30000);

  const isNewField = useMemo(() => {
    return newField && Object.keys(newField).length > 0 && Object.keys(newField).some(fieldId => fieldId !== defaultField?._id);
  }, [newField, defaultField]);

  const renderFieldGuide = () => {
    const checkFieldGuide = localStorage.getItem('checkFieldGuide');
    if (checkFieldGuide) {
      return null;
    }
    return (
      <div
        className="field-guide"
        onClick={e => {
          e.stopPropagation();
          setIsOpenedFieldGuide(false);
        }}
      >
        <img {...icUp} alt="up" className="field-guide-up" />
        <div className="field-guide-content">
          <div className="field-guide-content-text">
            👆{' '}
            <span>
              <IntlMessages id="field.guide.text" />
            </span>
          </div>
          <img {...icX} alt="x" className="cursor-pointer" />
        </div>
      </div>
    );
  };

  return (
    <div className="header-main">
      <div className="header-left">
        {isVietnam(user) && <img {...icMenu} alt="menu" onClick={onToggleNavCollapsed} style={{ cursor: 'pointer' }} />}
        <div className={`header-field-button-wrapper ${isNewField ? 'new' : ''}`}>
          <div
            style={
              navCollapsed || !isVietnam(user)
                ? {}
                : {
                    marginLeft: '117px',
                  }
            }
            className={`cursor-pointer no-drag header-field-button`}
            onClick={onToggleFieldCollapsed}
            data-field-toggle="true"
          >
            <img {...icPin} alt="pin" />
            <span>{isDashboardAll ? formatMessage({ id: 'field.all' }) : defaultField?.name}</span>
            <img {...icArrowDown} alt="arrow" style={{ transform: fieldCollapsed ? 'rotate(0deg)' : 'rotate(180deg)' }} />
            {isOpenedFieldGuide && renderFieldGuide()}
          </div>
        </div>
      </div>
      <div className="header-right">
        <div className="header-notification-button cursor-pointer no-drag" onClick={onToggleNotyCollapsed} data-notification-toggle="true">
          <img {...icNoty} alt="noty" style={{ width: 18, height: 18 }} />
          <span className="header-notification-title">
            <IntlMessages id="header.notification.title" />
          </span>
          <span className="header-notification-count">{count}</span>
        </div>
        <UserBlock />
      </div>
    </div>
  );
};

export default Header;
